/**
 * Work Feed JavaScript
 *
 * This file defines behaviors of
 * the Work Feed block.
 */

import parent from '../../util/parent';

// if we have anchor links
document.querySelectorAll('.case-feed')?.forEach((project) => {
	/**
	 * Setup inital vars for this project
	 */
	// get all the links
	const links = project.querySelectorAll('.case-feed__row');

	// define the color options (except for the parent's background color)
	let lastColor = '';
	let colors = [
		'has-0-900-background-color',
		'has-0-500-background-color',
		'has-1-500-background-color',
		'has-2-800-background-color',
		'has-2-200-background-color',
		'has-1-800-background-color',
	];
	const group = parent(project, '.wp-block-group');
	if (group) {
		const groupBg = [...group.classList].find((className) => {
			return className.endsWith('-background-color');
		});
		if (groupBg) {
			colors = colors.filter((color) => color !== groupBg);
		}
	}

	/**
	 * Apply functionality to each link
	 */
	links?.forEach((el) => {
		/**
		 * Handle background colors
		 */
		el.addEventListener('mouseenter', () => {
			let newColor = '';
			let i = 100; // just in case...
			// within this list we never want to reuse the same color back-to-back
			do {
				newColor = colors[Math.floor(Math.random() * colors.length)];
			} while (newColor === lastColor && --i > 0);
			lastColor = newColor;
			el.setAttribute(
				'class',
				`case-feed__row force-text-colors ${newColor}`
			);
		});

		/**
		 * Show synced thumbnails on mouseover
		 */
		el.addEventListener('mousemove', (e) => {
			project.style.setProperty(
				'--case-feed-thumb',
				(e.clientX - el.firstElementChild.offsetLeft) /
					el.firstElementChild.offsetWidth
			);
		});
	});
});
